'use client'

import { TContentfulComponents } from 'types/contentful/contentfulComponents'
import { ContentfulPage } from 'app/_components/ContentfulPage/ContentfulPage'

export function TopProductFeaturesClient({
  sectionComponents,
}: {
  sectionComponents: TContentfulComponents
}) {
  return (
    <>
      <div className="col-span-1 col-start-1 lg:overflow-hidden">
        <ContentfulPage componentsProps={sectionComponents} />
      </div>
    </>
  )
}
